import React, { useState } from "react";
import { Table, Pagination } from "antd";
import ModalLayout from "../../../ModalLayout";
import "./style.scss";

type Props = {
  open: boolean;
  onClose: () => void;
  record: any;
};

const ServiceDetailsModal: React.FC<Props> = ({ open, onClose, record }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const STATUS_CLASS_MAP: { [key: string]: string } = {
    Pending: "status-pending",
    Active: "status-active",
  };
  const columns = [
    {
      title: "Serial number",
      dataIndex: "serial_no",
      key: "serial_no",
      width: "180px",
    },
    {
      title: "Delivered date & time",
      dataIndex: "delivered_time",
      key: "delivered_time",
      width: "260px",
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      render: (_: any, record: any) => (
        <span
          className={`status-pill ${STATUS_CLASS_MAP[record.status] || ""}`}
        >
          {record.status}
        </span>
      ),
    },
  ];

  const detailsList = (record?.binDetails ?? []).map((item, index) => ({
    key: index + 1,
    serial_no: item.serial_no,
    delivered_time: item.installation_date || "-",
    status: item.status,
  }));

  console.log("detailsList", detailsList);

  return (
    <ModalLayout
      open={open}
      onClose={onClose}
      title={record?.serviceRef || "Service Details"}
      width={900}
      closable
      closeBtnText={null}
      secondaryBtnText={null}
    >
      <div className="service-details-container">
        <div className="service-details-wrapper">
          <div className="service-details-header"></div>

          <div className="service-details-grid">
            <div>
              <p className="label">Service name</p>
              <p className="value">{record?.productName}</p>
            </div>

            <div>
              <p className="label">Service type</p>
              <p className="value">{record?.serviceType}</p>
            </div>

            <div>
              <p className="label">Status</p>
              <span
                className={`status-pill ${STATUS_CLASS_MAP[record?.status]}`}
              >
                {record?.status}
              </span>
            </div>

            <div>
              <p className="label">Created date</p>
              <p className="value">{record?.installationDate}</p>
            </div>

            <div>
              <p className="label">Quantity</p>
              <p className="value">{record?.qty} pieces</p>
            </div>
          </div>
        </div>

        <div className="service-table-section">
          <Table
            className="service-details-table"
            columns={columns}
            dataSource={detailsList}
            pagination={false}
          />
          {/* <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: 16,
            }}
          >
            <div style={{ fontSize: 13, fontWeight: 400, color: "#1E1E1E" }}>
              Page{" "}
              <input
                type="number"
                value={currentPage}
                min={1}
                max={10}
                onChange={(e) => setCurrentPage(Number(e.target.value))}
                style={{
                  width: 40,
                  padding: "2px 6px",
                  border: "1px solid #ddd",
                  borderRadius: 4,
                  marginRight: 8,
                }}
              />
              of 10
            </div>
            <Pagination
              current={currentPage}
              pageSize={8}
              total={80}
              onChange={(page) => setCurrentPage(page)}
              showSizeChanger={false}
            />
          </div> */}
        </div>
      </div>
    </ModalLayout>
  );
};

export default ServiceDetailsModal;
